import styles from './LandingHeader.module.css';
import { Space, Typography } from 'antd';
import { APP_NAME } from 'src/app/constants';

const { Title } = Typography;

const LandingHeader = () => {
  return (
    <div className={styles.LandingHeader}>
      <Space direction="horizontal" style={{ marginLeft: 12 }}>
        <img src="/Blue_small use.png" className={styles['ProductName--Image']} />
        <Title className={styles['LandingHeader--Title']}>{APP_NAME}</Title>
      </Space>
    </div>
  );
};

export default LandingHeader;
